<div class="container-fluid mt-3 animate__animated animate__fadeIn animate__faster">
  <div class="flex justify-content-center text-center mt-5">
    <h3 class="opacity-70">Espere por favor...</h3>
  </div>
  <div class="flex justify-content-center text-center">
    <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration="2s"></p-progressSpinner>
  </div>
</div>
